export const normalizeId = (value) =>
  (value === undefined || value === null || value === '') ? null : String(value);

export const parseNumericId = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const parsed = Number.parseInt(String(value), 10);
  return Number.isFinite(parsed) ? parsed : null;
};
